import React from "react";
var __jsx = React.createElement;
import Lottie from 'lottie-react';
import { Box } from "../Layout";
import animationData from "./loading.json";
var defaultLottieProps = {
  width: 64,
  height: 64,
  boxProps: {}
};

var LottieLoading = _ref => {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? defaultLottieProps.width : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? defaultLottieProps.height : _ref$height,
      _ref$boxProps = _ref.boxProps,
      boxProps = _ref$boxProps === void 0 ? defaultLottieProps.boxProps : _ref$boxProps;
  return __jsx(Box, boxProps, __jsx(Lottie, {
    animationData: animationData,
    loop: true,
    style: {
      width,
      height,
      margin: '0 auto'
    }
  }));
};

export default LottieLoading;